import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function TableRowElement({
  children,
  attributes,
  nodeProps
}) {
  return _jsx("tr", {
    ...attributes,
    ...nodeProps,
    children: children
  });
}
export default TableRowElement;